/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HeadcountRollup } from './HeadcountRollup';
import type { WireframeReportPillar } from './WireframeReportPillar';
import type { WireframeReportSpend } from './WireframeReportSpend';

export type WireframeReportResponse = {
    timeframe: string;
    view: WireframeReportResponse.view;
    narrative_root_workstream_id: number;
    headcount: HeadcountRollup;
    spend: WireframeReportSpend;
    pillars: Array<WireframeReportPillar>;
};

export namespace WireframeReportResponse {

    export enum view {
        FULL = 'full',
        ADJUSTED = 'adjusted',
    }


}

